// extracted by mini-css-extract-plugin
export default {"wrapper":"CenterRightBox_wrapper__acJmI","top":"CenterRightBox_top__KLzFj","bottom":"CenterRightBox_bottom__g69iI"};